import React from "react";
import { useSelector } from "react-redux";
import { useTheme } from "@tvg/design-system";
import { formatPurseWithoutCurrency } from "@tvg/formatter/currency";
import { getBalance, getBalancePreference } from "@urp/store-selectors";
import Icon from "@fdr/static-ui/Icons";
import { depositSecondary } from "@fdr/static-ui/Icons/icons";
import { onTriggerDeposit } from "@tvg/sh-lib-account-wallet/src/utils/mobileUtils";
import {
  FDTVOverlayContainer,
  LiveBadgeText,
  BalanceBadge,
  BalanceBadgeText,
  ResultedBadgeText
} from "./styled-components";

interface FDTVVideoOverlayProps {
  isReplay?: boolean;
}

const FDTVVideoOverlay = ({ isReplay }: FDTVVideoOverlayProps) => {
  const theme = useTheme();
  const userBalance = useSelector(getBalance);
  const userBalancePreference = useSelector(getBalancePreference);

  const shouldDisplayUserBalance = userBalancePreference === "1";

  return (
    <FDTVOverlayContainer data-qa-label="fdtv-overlay-container">
      {isReplay ? (
        <ResultedBadgeText>Resulted</ResultedBadgeText>
      ) : (
        <>
          <LiveBadgeText data-qa-label="live-text">Live</LiveBadgeText>

          {shouldDisplayUserBalance && (
            <BalanceBadge
              data-qa-label="balance-badge"
              as="button"
              onClick={onTriggerDeposit}
            >
              <Icon
                size={20}
                icon={depositSecondary}
                color={theme.colors.white[100]}
                viewBoxSize={24}
              />

              <BalanceBadgeText>
                {formatPurseWithoutCurrency(userBalance ?? 0)}
              </BalanceBadgeText>
            </BalanceBadge>
          )}
        </>
      )}
    </FDTVOverlayContainer>
  );
};

export default FDTVVideoOverlay;
